export const mergeObjects = <T>({
  source,
  target,
}: {
  source: T;
  target: Partial<T>;
}): T => {
  if (
    !source ||
    typeof source !== 'object' ||
    Array.isArray(source) ||
    !target ||
    typeof target !== 'object' ||
    Array.isArray(target)
  ) {
    return (target ?? source) as T;
  }

  return {
    ...source,
    ...Object.entries(target).reduce((acc, [key, value]) => {
      const sourceValue = (source as Record<string, unknown>)[key];
      const targetValue = value as unknown;

      if (
        sourceValue &&
        typeof sourceValue === 'object' &&
        !Array.isArray(sourceValue) &&
        targetValue &&
        typeof targetValue === 'object' &&
        !Array.isArray(targetValue)
      ) {
        return {
          ...acc,
          [key]: mergeObjects({
            source: sourceValue as Record<string, unknown>,
            target: targetValue as Partial<Record<string, unknown>>,
          }),
        };
      }

      return {
        ...acc,
        [key]: targetValue === undefined ? sourceValue : targetValue,
      };
    }, {} as Partial<T>),
  };
};
